import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfServicesMps
export const getBillOfServicesMps = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-services-mp`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-services-mp:", error.response?.data || error);
    throw error;
  }
};

// GET a single billOfServicesMp
export const getBillOfServicesMpById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-services-mp/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-services-mp:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new billOfServicesMp
export const createBillOfServicesMp = async (billOfServicesMpData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/bill-of-services-mp`, billOfServicesMpData);
    return response.data;
  } catch (error) {
    console.error("Error creating bill-of-services-mp:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing billOfServicesMp
export const updateBillOfServicesMp = async (id, billOfServicesMpData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/bill-of-services-mp/${id}`, billOfServicesMpData);
    return response.data;
  } catch (error) {
    console.error("Error updating bill-of-services-mp:", error.response?.data || error);
    throw error;
  }
};

// DELETE a billOfServicesMp
export const deleteBillOfServicesMp = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/bill-of-services-mp/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting bill-of-services-mp:", error.response?.data || error);
    throw error;
  }
};

// GET billOfServicesMps by maintenancePlanId
export const getBillOfServicesMpsByMaintenancePlanId = async (maintenancePlanId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-services-mp`, {      params: { maintenancePlanId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bill-of-services-mp:', error.response?.data || error);
    throw error;
  }
};
